import { SympaConnectForm } from "./sources/sympahr";
import { SaimaHrConnectForm } from "./sources/saimahr";
import { ConnectFormProps } from "./views/DataSourceConnectionSetupView/steps/DataSourceConnectionForm";
import { PlanMillConnectForm } from "./sources/planmill";
import { PersonioConnectForm, PersonioReportConnectForm } from "./sources/personio";
import { PersonioV2ConnectForm } from "./sources/personiov2";
import { CsvConnectForm } from "./sources/csv";
import { GoogleDriveCsvConnectForm } from "./sources/drivecsv";
import { HiBobConnectForm, HiBobReportConnectForm } from "./sources/hibob";
import { GoogleDriveSheetConnectForm } from "./sources/drivesheet";
import { GreenhouseConnectForm } from "./sources/greenhouse";
import { BambooHrConnectForm } from "./sources/bamboohr";
import { TeamTailorConnectForm } from "./sources/teamtailor";
import { GoogleFormsConnectForm } from "./sources/googleforms";
import { SeveraConnectForm } from "./sources/severa";
import { EmailDataSourceConnectForm } from "./sources/email";
import { CsvUploadConnectForm, CsvUploadPreviewBuilder } from "./sources/csvupload";
import { DoceboConnectForm } from "./sources/docebo";
import { JiraConnectForm } from "./sources/jira";
import { OracleHcmConnectForm } from "./sources/oraclehcm";
import { DocuSignConnectForm } from "./sources/docusign";
import { HarvestConnectForm } from "./sources/harvest";
import { LeverConnectForm } from "./sources/lever";
import { PushApiConnectForm } from "./sources/pushapi";
import { WorkableConnectForm } from "./sources/workable";
import { SharepointConnectForm } from "./sources/sharepoint/sharepoint";
import { SharepointFolderConnectForm } from "./sources/sharepoint/sharepointfolder";
import { GoogleWorkspaceConnectForm } from "./sources/googleworkspace";
import { GimletLmsConnectForm } from "./sources/gimletlms";
import { OttaConnectForm } from "./sources/otta";
import { SalesforceConnectForm } from "./sources/salesforce";

export type PreviewBuilderProps = {
  sourceId: string;
  onPreview: (preLoadedData?: any[]) => Promise<void>;
  onCancel: () => void;
};

export type DataSourceSpec = {
  key: string;
  title: string;
  ConnectForm: (props: ConnectFormProps) => JSX.Element;
  PreviewBuilder?: (props: PreviewBuilderProps) => JSX.Element;
  hidden?: boolean;
  reconnect?: boolean;
  updateCredentials?: boolean;
  // Only feeds DataStudio dataset syncs: no employee mapping, filters or employee sync
  datasetSyncOnly?: boolean;
};

export const DataSources: DataSourceSpec[] = [
  {
    key: "bamboohr",
    title: "BambooHR",
    ConnectForm: BambooHrConnectForm,
    updateCredentials: true
  },
  {
    key: "hibob",
    title: "Bob",
    ConnectForm: HiBobConnectForm,
    updateCredentials: true
  },
  {
    key: "hibobreport",
    title: "Bob Report",
    ConnectForm: HiBobReportConnectForm,
    updateCredentials: true
  },
  {
    key: "csv",
    title: "CSV from URL",
    ConnectForm: CsvConnectForm,
    updateCredentials: true
  },
  {
    key: "csv-upload",
    title: "CSV File Upload",
    ConnectForm: CsvUploadConnectForm,
    PreviewBuilder: CsvUploadPreviewBuilder
  },
  {
    key: "docebo",
    title: "Docebo",
    ConnectForm: DoceboConnectForm,
    reconnect: true
  },
  {
    key: "docusign",
    title: "DocuSign",
    ConnectForm: DocuSignConnectForm,
    reconnect: true
  },
  {
    key: "drive_csv",
    title: "Google Drive CSV",
    ConnectForm: GoogleDriveCsvConnectForm,
    updateCredentials: true
  },
  {
    key: "drivesheet",
    title: "Google Drive Sheet",
    ConnectForm: GoogleDriveSheetConnectForm,
    updateCredentials: true
  },
  {
    key: "email",
    title: "Email",
    ConnectForm: EmailDataSourceConnectForm
  },
  {
    key: "googleforms",
    title: "Google Forms",
    ConnectForm: GoogleFormsConnectForm,
    updateCredentials: true
  },
  {
    key: "googleworkspace",
    title: "Google Workspace",
    ConnectForm: GoogleWorkspaceConnectForm,
    updateCredentials: true
  },
  {
    key: "gimletlms",
    title: "Gimlet LMS",
    ConnectForm: GimletLmsConnectForm,
    updateCredentials: true
  },
  {
    key: "greenhouse",
    title: "Greenhouse",
    ConnectForm: GreenhouseConnectForm,
    updateCredentials: true
  },
  {
    key: "harvest",
    title: "Harvest",
    ConnectForm: HarvestConnectForm,
    updateCredentials: true
  },
  {
    key: "jira",
    title: "Jira",
    ConnectForm: JiraConnectForm,
    updateCredentials: true
  },
  {
    key: "lever",
    title: "Lever",
    ConnectForm: LeverConnectForm,
    reconnect: true
  },
  {
    key: "teamtailor",
    title: "TeamTailor",
    ConnectForm: TeamTailorConnectForm,
    updateCredentials: true
  },
  {
    key: "personio",
    title: "Personio",
    ConnectForm: PersonioConnectForm,
    updateCredentials: true
  },
  {
    key: "personioreport",
    title: "Personio Report",
    ConnectForm: PersonioReportConnectForm,
    updateCredentials: true
  },
  {
    key: "personiov2",
    title: "Personio (v2)",
    ConnectForm: PersonioV2ConnectForm,
    updateCredentials: true
  },
  {
    key: "planmill",
    title: "Planmill",
    ConnectForm: PlanMillConnectForm,
    updateCredentials: true
  },
  {
    key: "pushapi",
    title: "Push API",
    ConnectForm: PushApiConnectForm,
    updateCredentials: true
  },
  { key: "severa", title: "Severa", ConnectForm: SeveraConnectForm, updateCredentials: true },
  {
    key: "saimahr",
    title: "Saima HR",
    ConnectForm: SaimaHrConnectForm,
    updateCredentials: true
  },
  {
    key: "salesforce",
    title: "Salesforce",
    ConnectForm: SalesforceConnectForm,
    updateCredentials: true,
    datasetSyncOnly: true
  },
  {
    key: "sharepoint",
    title: "Sharepoint",
    ConnectForm: SharepointConnectForm,
    updateCredentials: true
  },
  {
    key: "sharepointfolder",
    title: "Sharepoint Folder",
    ConnectForm: SharepointFolderConnectForm,
    updateCredentials: true
  },
  {
    key: "sympahr",
    title: "Sympa HR",
    ConnectForm: SympaConnectForm,
    updateCredentials: true
  },
  {
    key: "oraclehcm",
    title: "Oracle HCM",
    ConnectForm: OracleHcmConnectForm,
    updateCredentials: true
  },
  {
    key: "otta",
    title: "Otta",
    ConnectForm: OttaConnectForm,
    updateCredentials: true
  },
  {
    key: "workable",
    title: "Workable",
    ConnectForm: WorkableConnectForm,
    updateCredentials: true
  },
  {
    key: "inari",
    title: "Inari",
    ConnectForm: () => {
      return <div />;
    },
    hidden: true
  }
];

export const getDataSourceSpec = (dataSource: string) => {
  const spec = DataSources.find(ds => ds.key === dataSource);
  if (!spec) {
    throw new Error(`No data source ${dataSource}`);
  }
  return spec;
};
